const qrcodeType = {
  static: 'static',
  immediateCollection: 'immediate_collection',
  dueDateCollection: 'due_date_collection'
};

module.exports = qrcodeType;
